import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import IframeResizer from 'iframe-resizer-react'
import { Box } from '@mui/material_modern'

const IFrameComponent = ({ title, src }) => {
  const isExploIFrame = src.includes('explo.co')
  const ref = useRef()
  const getOffset = () => ref?.current?.offsetTop || 0

  const [offset, setOffset] = useState(getOffset())

  useEffect(() => {
    if (isExploIFrame) {
      setOffset(getOffset())
    }
  }, [])

  // return the IFrameComponent stying appropriate for either Explo or Metabase legacy
  return (
    <Box ref={ref}>
      {isExploIFrame ? (
        <IframeResizer
          log
          id="current-dashboard"
          src={src}
          style={{
            width: '1px',
            minWidth: '100%',
            height: `calc(100vh - ${offset}px - 8px)`,
          }}
          title={title}
          scrolling="yes"
          frameBorder={0}
        />
      ) : (
        <IframeResizer log src={src} style={{ width: '1px', minWidth: '100%' }} title={title} frameBorder={0} />
      )}
    </Box>
  )
}

IFrameComponent.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default IFrameComponent
